import { useState } from "react";
import { businessTickets, type BusinessSupportTicket } from "../../../mocks/businessData";

const PRIORITY_CONFIG = {
  high:   { label: "Yüksek", class: "text-red-600 bg-red-50" },
  medium: { label: "Orta",   class: "text-amber-600 bg-amber-50" },
  low:    { label: "Düşük",  class: "text-stone-500 bg-stone-50" },
};
const STATUS_CONFIG = {
  open:        { label: "Açık",      class: "bg-red-100 text-red-700" },
  in_progress: { label: "İşlemde",   class: "bg-amber-100 text-amber-700" },
  resolved:    { label: "Çözüldü",   class: "bg-emerald-100 text-emerald-700" },
  closed:      { label: "Kapatıldı", class: "bg-stone-100 text-stone-500" },
};

const SUPPORT_FORM_URL = "https://readdy.ai/api/form/d74im14prit363gl0me0";

export default function BusinessSupportSection() {
  const [tickets] = useState<BusinessSupportTicket[]>(businessTickets);
  const [showForm, setShowForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [selected, setSelected] = useState<BusinessSupportTicket | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams();
    new FormData(form).forEach((val, key) => data.append(key, val.toString()));
    try {
      await fetch(SUPPORT_FORM_URL, { method: "POST", body: data });
    } catch { /* ignore */ }
    setSubmitted(true);
    setTimeout(() => { setSubmitted(false); setShowForm(false); }, 2500);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-semibold text-stone-800">Destek Taleplerim</h2>
          <p className="text-sm text-stone-400 mt-0.5">{tickets.length} talep · {tickets.filter((t) => t.status === "open").length} açık</p>
        </div>
        <button
          onClick={() => setShowForm(!showForm)}
          className="flex items-center gap-2 bg-emerald-700 hover:bg-emerald-800 text-white px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-add-line" /> Yeni Talep
        </button>
      </div>

      {/* New ticket form */}
      {showForm && (
        <div className="bg-white rounded-2xl border border-emerald-200 p-5">
          <h3 className="font-semibold text-stone-800 mb-4 flex items-center gap-2">
            <i className="ri-customer-service-2-line text-emerald-600" /> Yeni Destek Talebi
          </h3>
          {submitted ? (
            <div className="py-8 text-center">
              <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-check-line text-emerald-600 text-2xl" />
              </div>
              <p className="font-semibold text-stone-800">Talebiniz alındı!</p>
              <p className="text-sm text-stone-400 mt-1">En kısa sürede size dönüş yapılacaktır.</p>
            </div>
          ) : (
            <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
              <input type="hidden" name="business_name" value="Kebapçı İskender" />
              <input type="hidden" name="email" value="info@iskender.com.tr" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs text-stone-500 mb-1.5">Konu *</label>
                  <input name="subject" type="text" required placeholder="Konu başlığı"
                    className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400" />
                </div>
                <div>
                  <label className="block text-xs text-stone-500 mb-1.5">Kategori *</label>
                  <select name="category" required className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none cursor-pointer text-stone-700">
                    <option value="">Seçin...</option>
                    <option value="Teknik">Teknik Sorun</option>
                    <option value="İçerik">İçerik Güncelleme</option>
                    <option value="Fatura">Fatura/Ödeme</option>
                    <option value="Genel">Genel</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs text-stone-500 mb-1.5">Öncelik</label>
                  <select name="priority" className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none cursor-pointer text-stone-700">
                    <option value="low">Düşük</option>
                    <option value="medium">Orta</option>
                    <option value="high">Yüksek</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-xs text-stone-500 mb-1.5">Mesaj *</label>
                <textarea name="message" required rows={4} maxLength={500} placeholder="Sorununuzu detaylıca açıklayın..."
                  className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400 resize-none" />
              </div>
              <div className="flex gap-3">
                <button type="button" onClick={() => setShowForm(false)}
                  className="flex-1 py-2.5 border border-stone-200 rounded-xl text-sm text-stone-600 hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap">
                  İptal
                </button>
                <button type="submit"
                  className="flex-1 py-2.5 bg-emerald-700 hover:bg-emerald-800 text-white rounded-xl text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  Talebi Gönder
                </button>
              </div>
            </form>
          )}
        </div>
      )}

      {/* Tickets split view */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {/* List */}
        <div className="space-y-3">
          {tickets.map((ticket) => {
            const stat = STATUS_CONFIG[ticket.status];
            const prio = PRIORITY_CONFIG[ticket.priority];
            return (
              <div key={ticket.id} onClick={() => setSelected(ticket)}
                className={`bg-white rounded-2xl border p-4 cursor-pointer transition-all hover:border-stone-300 ${selected?.id === ticket.id ? "border-emerald-300" : "border-stone-100"}`}>
                <div className="flex items-center justify-between gap-2 mb-2">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-mono text-stone-400">{ticket.ticketNo}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${stat.class}`}>{stat.label}</span>
                  </div>
                  <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${prio.class}`}>{prio.label}</span>
                </div>
                <p className="font-medium text-stone-800 text-sm mb-1">{ticket.subject}</p>
                <p className="text-xs text-stone-400 line-clamp-1">{ticket.message}</p>
                <p className="text-xs text-stone-400 mt-2">{ticket.category} · {ticket.createdAt}</p>
              </div>
            );
          })}
        </div>

        {/* Detail */}
        <div className="bg-white rounded-2xl border border-stone-100 min-h-[200px]">
          {selected ? (
            <div className="p-5">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-mono text-xs text-stone-400">{selected.ticketNo}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_CONFIG[selected.status].class}`}>{STATUS_CONFIG[selected.status].label}</span>
                  </div>
                  <h3 className="font-bold text-stone-800">{selected.subject}</h3>
                </div>
              </div>

              {/* Your message */}
              <div className="bg-stone-50 rounded-xl p-4 mb-3">
                <p className="text-xs text-stone-400 mb-2">Talebiniz · {selected.createdAt}</p>
                <p className="text-sm text-stone-700 leading-relaxed">{selected.message}</p>
              </div>

              {/* Admin reply */}
              {selected.adminReply ? (
                <div className="bg-emerald-50 border border-emerald-100 rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-5 h-5 rounded-full bg-emerald-700 flex items-center justify-center">
                      <i className="ri-customer-service-2-line text-white text-xs" />
                    </div>
                    <p className="text-xs font-semibold text-emerald-700">BursaGuide360 Destek</p>
                  </div>
                  <p className="text-sm text-stone-700 leading-relaxed">{selected.adminReply}</p>
                </div>
              ) : (
                <div className="flex items-center gap-2 text-stone-400 text-sm py-4">
                  <i className="ri-time-line" />
                  <span>Henüz yanıt bekleniyor...</span>
                </div>
              )}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center h-48 text-stone-300">
              <i className="ri-customer-service-2-line text-4xl mb-3" />
              <p className="text-sm">Bir talep seçin</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
